/**
 * Tên nguồn lập dự toán
 * vcdoan 29.03.2024
 */
export default {
    Sources: 1,
    Activities: 2,
    Fees: 3,
    SalaryReform: 4
  };